import {Routes, Route} from 'react-router-dom';

import Home from '../Home/Home';
import Interest from '../Interest/Interest';
import FormCompleted from '../FormCompleted/FormCompleted';
import Terms from '../Terms/Terms';

const App = () => {

	return(
		<Routes>
			<Route path='/' element={<Home />}></Route>
			<Route path='/interest' element={<Interest />}></Route>
			<Route path='/interest/complete' element={<FormCompleted />}></Route>
			<Route path='/terms' element={<Terms />}></Route>
		</Routes>
	)

}

export default App;
